import React from 'react'
import { Modal } from '@enamelai/design-system'

type ChartingDiscardInProgressModalProps = {
  show: boolean
  chartName: string
  variant?: 'dental' | 'perio'
  onKeepEditing: () => void
  onDiscard: () => void
}

const ChartingDiscardInProgressModal: React.FC<
  ChartingDiscardInProgressModalProps
> = ({ show, chartName, variant = 'dental', onKeepEditing, onDiscard }) => {
  const name = chartName.trim() || 'this chart'
  const isPerio = variant === 'perio'

  return (
    <Modal
      open={show}
      onClose={onKeepEditing}
      size="xs"
      title={isPerio ? 'Discard new chart' : 'Discard chart in progress'}
      description={
        isPerio
          ? `You're creating a new chart. If you switch to edit ${name}, your current progress with the new chart will be lost.`
          : `You're creating a new chart. If you switch to edit "${name}", your current progress will be lost.`
      }
      primaryLabel="Discard"
      secondaryLabel="Keep editing"
      primaryDestructive
      onPrimaryClick={onDiscard}
      onSecondaryClick={onKeepEditing}
    />
  )
}

export default ChartingDiscardInProgressModal
